import { render, staticRenderFns } from "./KOptionalText.vue?vue&type=template&id=22385eae&scoped=true"
import script from "./KOptionalText.vue?vue&type=script&lang=js"
export * from "./KOptionalText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22385eae",
  null
  
)

export default component.exports